import {
  USER_SUMMARY_FAILD,
  USER_SUMMARY_LOADING,
  USER_SUMMARY_SUCCESS,
} from "../types";

const initialState = {
  userSummary: null,
  loading: false,
  error: null,
};

export const userSummaryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case USER_SUMMARY_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case USER_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        userSummary: action.payload,
      };
    case USER_SUMMARY_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
